import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/69cb592fc3f8480013ed3de3/atelier/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/69cb592fc3f8480013ed3de3/atelier/src/components/ui/AppLogo.tsx");
